import type { Theme } from "@mui/material/styles";
import palette from "./palette";

const table = {
  MuiTable: {
    styleOverrides: {

    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        backgroundColor: '#fff',
        borderBottom: `1px solid ${palette.grey[200]}`,
        borderTop: `1px solid ${palette.grey[200]}`,
        padding: '4px 10px',
        transition: theme.transitions.create(
          ['background-color', 'color'],
        ),
        '&:first-of-type': {
          borderLeft: `1px solid ${palette.grey[200]}`,
        },
        '&:last-of-type': {
          borderRight: `1px solid ${palette.grey[200]}`,
        },
        '.MuiTableRow-hover:hover &': {
          backgroundColor: palette.common.black,
          color: palette.common.white,
        },
      }),
      head: {
        padding: "11px 10px",
        '&:first-of-type': {
          borderTopLeftRadius: 6,
        },
        '&:last-of-type': {
          borderTopRightRadius: 6,
        },
      },
      body: {
        '.MuiTableRow-root:last-of-type &:first-of-type, .MuiTableRow-collapse:nth-last-of-type(2) &:first-of-type': {
          borderBottomLeftRadius: 6,
        },
        '.MuiTableRow-root:last-of-type &:last-of-type, .MuiTableRow-collapse:nth-last-of-type(2) &:last-of-type': {
          borderBottomRightRadius: 6,
        },
      },
    },
  },
};

export default table;
